import React from 'react';
import { List, Filter, Edit, Create, Datagrid, LongTextInput, ReferenceField, AutocompleteInput, TextField, NumberField, EditButton, DisabledInput, ReferenceInput, TabbedForm, FormTab, TextInput, ImageField, ImageInput, NumberInput } from 'admin-on-rest';

const FoodsFilters = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="query" alwaysOn />
    </Filter>
);

export const FoodsList = (props) => (
    <List {...props} filters={<FoodsFilters />}>
        <Datagrid>
            <TextField source="name" />
            <NumberField source="nutritional_values.carbohydrates" label="Carbohydrates" />
            <NumberField source="nutritional_values.protein" label="Protein" />
            <NumberField source="nutritional_values.fat" label="Fat" />
            <TextField source="label" />
            <TextField source="comment" />
            <NumberField source="calories" />
            <TextField source="recommendation" />
            <ReferenceField label="Category" source="category" reference="categories">
                <TextField source="name"/>
            </ReferenceField> 
            <ImageField source="cover_image.url" label="Cover image"/>            
            <EditButton />
        </Datagrid>
    </List>
);

export const FoodsEdit = (props) => (
    <Edit {...props}>
        <TabbedForm>
            <FormTab label="General">
                <DisabledInput source="id" />
                <TextInput source="name" />
                <TextInput source="label" />
                <LongTextInput source="comment" />
                <TextInput source="recommendation" />   
                <ReferenceInput label="Category" source="category" filterToQuery={searchText => ({ query: searchText })} reference="categories">
                    <AutocompleteInput source="id" optionText="name" optionValue="id"/>
                </ReferenceInput>          
                <ImageInput source="cover_image" label="Cover image" accept="image/*">
                    <ImageField source="url" />
                </ImageInput>     
            </FormTab>
            <FormTab label="Nutritonal Values">
                <NumberInput source="nutritional_values.carbohydrates" label="Carbohydrates"/>
                <NumberInput source="nutritional_values.protein" label="Protein"/>
                <NumberInput source="nutritional_values.fat" label="Fat"/>
                <NumberInput source="calories" />                
            </FormTab>
        </TabbedForm>
    </Edit>
);

export const FoodsCreate = (props) => (
    <Create {...props}>
        <TabbedForm>
            <FormTab label="General">
                <TextInput source="name" />
                <TextInput source="label" />
                <LongTextInput source="comment" />
                <TextInput source="recommendation" />   
                <ReferenceInput label="Category" source="category" reference="categories" filterToQuery={searchText => ({ query: searchText })} allowEmpty={true}>
                    <AutocompleteInput source="id" optionText="name" optionValue="id"/>
                </ReferenceInput>          
                <ImageInput source="cover_image" label="Cover image" accept="image/*">
                    <ImageField source="url" />
                </ImageInput>     
            </FormTab>
            <FormTab label="Nutritonal Values">
                <NumberInput source="nutritional_values.carbohydrates" label="Carbohydrates"/>
                <NumberInput source="nutritional_values.protein" label="Protein"/>
                <NumberInput source="nutritional_values.fat" label="Fat"/>
                <NumberInput source="calories" />                
            </FormTab>
        </TabbedForm>
    </Create>
);


// WEBPACK FOOTER //
// ./src/resources/foods.js